import { Play, Pause, Rewind, FastForward } from "lucide-react";
import { useRef, useState, useEffect } from "react";
import { beatsItems } from "@/data/beats";
import { beatUrl } from "@/lib/beatUrl";

export default function BeatsTeaserCard() {
    const [playingId, setPlayingId] = useState(null);
    const [progress, setProgress] = useState(0);
    const audioRef = useRef(null);

    /* PLAY / PAUSE */
    const togglePlay = (beat) => {
        if (!audioRef.current) return;

        if (playingId === beat.id) {
            audioRef.current.pause();
            setPlayingId(null);
        } else {
            const src = beatUrl(beat);
            if (!src) return;

            audioRef.current.src = src;
            audioRef.current.play();
            setPlayingId(beat.id);
        }
    };

    /* SKIP */
    const skip = (seconds) => {
        if (!audioRef.current) return;

        const audio = audioRef.current;
        audio.currentTime = Math.min(
            Math.max(0, audio.currentTime + seconds),
            audio.duration || 0
        );
    };

    /* PROGRESS UPDATE */
    useEffect(() => {
        const audio = audioRef.current;
        if (!audio) return;

        const update = () => {
            const percent =
                (audio.currentTime / audio.duration) * 100 || 0;
            setProgress(percent);
        };

        audio.addEventListener("timeupdate", update);

        return () => {
            audio.removeEventListener("timeupdate", update);
        };
    }, []);

    return (
        <div className="group relative h-[420px] rounded-2xl overflow-hidden border border-white/[0.06] bg-[#0A0A0A]">

            {/* GLOW */}
            <div className="absolute inset-0 bg-gradient-to-br from-[#7F00FF]/20 via-transparent to-transparent opacity-40 group-hover:opacity-70 transition" />

            {/* CONTENT */}
            <div className="relative h-full flex flex-col p-6">

                {/* LIST */}
                <div className="flex-1 flex flex-col justify-between">

                    {beatsItems.slice(0, 3).map((beat) => (
                        <div
                            key={beat.id}
                            className="
                flex flex-col justify-center
                border border-white/[0.06]
                rounded-xl
                px-4 py-3
                hover:bg-white/[0.03]
                transition h-[30%]
              "
                        >

                            {/* TOP */}
                            <div className="flex items-center justify-between">

                                {/* INFO */}
                                <div>
                                    <p className="font-syne text-xl">
                                        {beat.title}
                                    </p>
                                    <p className="text-white/40 text-xs">
                                        {beat.genre}
                                    </p>
                                </div>

                                {/* CONTROLS */}
                                <div className="flex items-center gap-2">

                                    {/* BACK */}
                                    {playingId === beat.id && (
                                        <button
                                            onClick={() => skip(-10)}
                                            className="text-white/50 hover:text-white transition"
                                        >
                                            <Rewind className="w-4 h-4" />
                                        </button>
                                    )}

                                    {/* PLAY */}
                                    <button
                                        onClick={() => togglePlay(beat)}
                                        className="
                      w-10 h-10
                      flex items-center justify-center
                      rounded-full
                      bg-white text-black
                      hover:scale-105 transition
                    "
                                    >
                                        {playingId === beat.id ? (
                                            <Pause className="w-4 h-4" />
                                        ) : (
                                            <Play className="w-4 h-4 ml-0.5" />
                                        )}
                                    </button>

                                    {/* FORWARD */}
                                    {playingId === beat.id && (
                                        <button
                                            onClick={() => skip(10)}
                                            className="text-white/50 hover:text-white transition"
                                        >
                                            <FastForward className="w-4 h-4" />
                                        </button>
                                    )}

                                </div>
                            </div>

                            {/* PROGRESS (SADECE ÇALAN BEAT) */}
                            {playingId === beat.id && (
                                <div
                                    className="
                    mt-3 h-1.5
                    bg-white/10
                    rounded-full
                    overflow-hidden
                    cursor-pointer
                  "
                                    onClick={(e) => {
                                        const rect =
                                            e.currentTarget.getBoundingClientRect();
                                        const percent =
                                            (e.clientX - rect.left) / rect.width;

                                        if (audioRef.current) {
                                            audioRef.current.currentTime =
                                                percent * audioRef.current.duration;
                                        }
                                    }}
                                >
                                    <div
                                        className="
                      h-full
                      bg-gradient-to-r
                      from-[#7F00FF]
                      to-[#00E5FF]
                    "
                                        style={{ width: `${progress}%` }}
                                    />
                                </div>
                            )}

                        </div>
                    ))}

                </div>

                {/* AUDIO */}
                <audio ref={audioRef} />

            </div>
        </div>
    );
}
